var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 11,
    viewBox: "0 0 23 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.74 9.96187L20.1267 5.41063L22.7133 1.045C22.7747 0.940968 22.8083 0.821977 22.8104 0.700203C22.8126 0.578429 22.7834 0.458242 22.7258 0.35194C22.6681 0.245637 22.5841 0.157035 22.4824 0.0951973C22.3806 0.0333597 22.2648 0.000506788 22.1467 0H1.33333C0.979711 0 0.640573 0.144866 0.390524 0.402728C0.140476 0.660591 0 1.01033 0 1.375L0 9.625C0 9.98967 0.140476 10.3394 0.390524 10.5973C0.640573 10.8551 0.979711 11 1.33333 11H22.1667C22.2843 11 22.3999 10.9678 22.5016 10.9068C22.6034 10.8459 22.6876 10.7582 22.7458 10.6527C22.8041 10.5473 22.8342 10.4278 22.8332 10.3065C22.8322 10.1852 22.8 10.0663 22.74 9.96187ZM7.00667 7.68625H6.26L4.08667 4.7025V7.69313H3.33333V3.4375H4.08667L6.26667 6.42813V3.4375H7.01333L7.00667 7.68625ZM11.2267 4.125H8.87333V5.14937H11.0067V5.83687H8.87333V6.94375H11.2267V7.63125H8.12V3.4375H11.22L11.2267 4.125ZM16.7533 7.6725H16L14.9667 4.51687L13.9333 7.68625H13.1867L11.8533 3.4375H12.6667L13.5467 6.48313L14.56 3.4375H15.3733L16.3467 6.48313L17.2333 3.4375H18.0533L16.7533 7.6725Z",
    fill: "#FFA133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.e288f45b57f0847ff2e671ea489aa5fb.svg";
export { ForwardRef as ReactComponent };